import { useFormInstance } from '@neo/blocks/forms/form-provider'
import { useCallback } from 'react'
import type { AgentSettingsFormValues } from '../config/base.config'
import { useFlowStore } from '../store'

/**
 * Reads the current agent settings by merging values from all registered tab forms.
 * Each form owns specific fields — we pick only those to avoid stale defaults
 * from one form overwriting edits from another.
 */
export const useAgentSettingsFormValues = () => {
  const settingsForm = useFormInstance('agent-settings-tab-form')
  const voiceConfigForm = useFormInstance('voice-config-tab-form')
  const eventCallbacksForm = useFormInstance('event-callbacks-tab-form')

  const getSettingsFormValues = useCallback((): AgentSettingsFormValues => {
    const base = useFlowStore.getState().agentSettings
    const settingsValues = settingsForm?.state.values as AgentSettingsFormValues | undefined
    const voiceValues = voiceConfigForm?.state.values as AgentSettingsFormValues | undefined
    const callbackValues = eventCallbacksForm?.state.values as AgentSettingsFormValues | undefined
    return {
      ...base,
      // settingsForm owns schedule + knowledge_base_ids
      ...(settingsValues
        ? {
            schedule: settingsValues.schedule,
            knowledge_base_ids: settingsValues.knowledge_base_ids,
          }
        : {}),
      // voiceConfigForm owns voice_ai_config
      ...(voiceValues
        ? {
            voice_ai_config: voiceValues.voice_ai_config,
          }
        : {}),
      // eventCallbacksForm owns event_callbacks
      ...(callbackValues
        ? {
            event_callbacks: callbackValues.event_callbacks,
          }
        : {}),
    } as AgentSettingsFormValues
  }, [settingsForm, voiceConfigForm, eventCallbacksForm])

  return { getSettingsFormValues }
}
